const DATA_TEST_IDS = {
  fragmentsRoleFormView: 'module__module-page_role-form-view',
  fragmentsRoleItem: 'module__module-page_role-item',
} as const;

export default DATA_TEST_IDS;
